import { Segmented } from "antd";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router";

type CustomSegmentProps = {
  items: Array<{
    value: string;
    icon: React.ReactNode;
    component: React.ReactNode;
  }>;
  tabName?: string;
  isSetDefaultActive?: boolean;
  isShowComponent?: boolean;
  onChange?: (e: any) => void;
  shape?: "default" | "round";
};

export const CustomSegmented = ({
  items,
  tabName,
  onChange,
  isSetDefaultActive = false,
  isShowComponent = false,
  shape = "default",
}: CustomSegmentProps) => {
  const name = tabName ?? "view";
  const [searchParams, setSearchParams] = useSearchParams();
  const typeFromURL = searchParams.get(name);

  useEffect(() => {
    if (isSetDefaultActive) {
      const initialActive = searchParams.get(name);

      if (!initialActive) {
        const newParams = new URLSearchParams(searchParams);

        newParams.set(
          name,
          items?.[0]?.value?.toString()?.toLowerCase() as string
        );
        setSearchParams(newParams);
      }
    }
  }, [isSetDefaultActive]);

  const onChangeHandler = (key: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set(name, key.toString());
    setSearchParams(newParams);
    onChange && onChange(items?.find((item) => item?.value === key));
  };

  return (
    <>
      <div className="">
        <Segmented
          value={typeFromURL as string}
          options={items}
          shape={shape}
          onChange={onChangeHandler}
        />
      </div>
      {isShowComponent ? (
        <div className="">
          {items?.find((item) => item.value === typeFromURL)?.component}
        </div>
      ) : (
        ""
      )}
    </>
  );
};
